export function setDynamicCanonical() {
  let canonicalElem = document.querySelector<HTMLLinkElement>("[data-canonical-link]");

  // Create canonical link element if not present
  if (!canonicalElem) {
    canonicalElem = document.createElement("link");
    canonicalElem.rel = "canonical";
    canonicalElem.setAttribute("data-canonical-link", "");
    document.head.appendChild(canonicalElem);
  }

  const { pathname } = window.location;

  // Construct canonical URL
  let canonicalUrl = window.location.origin + pathname;

  // Special case: Homepage
  if (pathname === "/" || pathname === "/index" || pathname === "/index.html") {
    canonicalUrl = window.location.origin;
  }

  canonicalElem.href = canonicalUrl;

  console.log("Canonical tag set to:", canonicalUrl);
}
